<script>
  export let value = '';
</script>

<input bind:value on:input on:change {...$$restProps} />
